import React from "react";
import AboutSpiritPage from "../components/about/AboutSpiritPage";
import Seo from "../components/seo/Seo";
import { paths } from "../paths";

const About = () => {
  return (
    <div>
      <Seo
        title="About Spirit '26 | IIT Guwahati Annual Sports Fest"
        description="Learn about Spirit, the Annual Sports Fest of IIT Guwahati — its history, mission, and what makes it one of India's biggest inter-collegiate sporting events."
        path={paths.about}
      />
      <AboutSpiritPage />
    </div>
  );
};

export default About;
